import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

interface PainItem {
  painTitle: string;
  painDesc: string;
  needTitle: string;
  needDesc: string;
}

interface AgriPainPointsProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    items: PainItem[];
  };
}

export default function AgriPainPoints({ data }: AgriPainPointsProps) {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {data.items.map((item) => (
              <div
                key={item.painTitle}
                className="rounded-2xl border border-background-200 bg-background-100 overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className="p-6 md:p-7">
                  <div className="flex items-center gap-2 text-xs font-semibold text-foreground-400">
                    <i className="ri-error-warning-line"></i>
                    痛点现状
                  </div>
                  <h3 className="mt-3 font-heading font-bold text-foreground-950 text-lg leading-snug">
                    {item.painTitle}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.painDesc}</p>
                </div>

                <div className="border-t border-dashed border-background-300 bg-background-50 p-6 md:p-7">
                  <div className="flex items-center gap-2 text-xs font-semibold text-accent-600">
                    <i className="ri-user-heart-line"></i>
                    农户核心诉求
                  </div>
                  <h4 className="mt-3 font-heading font-bold text-foreground-950 text-base leading-snug">
                    {item.needTitle}
                  </h4>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.needDesc}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}